export interface Limitation {
  maxUserPerCompany: number;
  maxRealProjectsInCompany: number;
}

export interface StripeRecurring {
  aggregate_usage: null;
  interval: 'month' | 'year' | 'week' | 'day';
  interval_count: number;
  meter: null;
  trial_period_days: null;
  usage_type: 'licensed' | 'metered';
}

export interface StripePrice {
  id: string;
  object: string;
  active: boolean;
  billing_scheme: string;
  created: number;
  currency: string;
  custom_unit_amount: null;
  livemode: boolean;
  lookup_key: null;
  metadata: Record<string, unknown>;
  nickname: null;
  product: string;
  recurring: StripeRecurring;
  tax_behavior: string;
  tiers_mode: null;
  transform_quantity: null;
  type: 'recurring' | 'one_time';
  unit_amount: number;
  unit_amount_decimal: string;
}

export interface StripeProduct {
  id: string;
  object: string;
  active: boolean;
  attributes: string[];
  created: number;
  default_price: null;
  description: string;
  images: string[];
  livemode: boolean;
  marketing_features: string[];
  metadata: Record<string, unknown>;
  name: string;
  package_dimensions: null;
  shippable: null;
  statement_descriptor: null;
  tax_code: null;
  type: any;
  unit_label: null;
  updated: number;
  url: null;
}

export interface PricingPlan {
  _id: string;
  deletedAt: null;
  stripeProductId: string;
  type: string; // Add other possible types if they exist
  limitation: Limitation;
  createdAt: string;
  updatedAt: string;
  __v: number;
  stripeProduct: StripeProduct;
  stripePrices: StripePrice[];
}

export interface RecurringIntervalPrice {
  id: string;
  price: number;
  currency: string;
  metadata: Record<string, unknown>;
  addOnPrice?: number;
  addOnPrices?: RecurringIntervalPrice[];
}

export interface PricingPlanMapped {
  _id: string;
  stripeProductId: string;
  limitations: Limitation;
  oldPrice: number;
  newPrice: number;
  name: string;
  type: string;
  description: string;
  metadata: Record<string, unknown>;
  monthly: Record<string, RecurringIntervalPrice>;
  yearly: Record<string, RecurringIntervalPrice>;
}

export interface StripeCard {
  last4: string;
  display_brand: string;
  exp_year: number;
  exp_month: number;
}

export interface StripePaymentMethod {
  card: StripeCard;
  type: string;
}

export interface StripeData {
  stripePaymentMethod: StripePaymentMethod;
  stripePrice: StripePrice;
  stripeProduct: StripeProduct;
  stripeSubscription: any;
}

export interface UserSubscription {
  _id: string;
  active: boolean;
  status: StripeStatus;
  company: string;
  maxUserPerCompany: number;
  maxRealProjectsInCompany: number;
  stripePriceId: string;
  stripeSubscriptionId: string;
  defaultPaymentMethodId: string;
  stripeData: StripeData;
  isCanceled: boolean;
}

export enum StripeStatus {
  ACTIVE = 'active',
  CANCELED = 'canceled',
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired',
  PAST_DUE = 'past_due',
  PAUSED = 'paused',
  TRIALING = 'trialing',
  UNPAID = 'unpaid',
}
